<template>
  <v-dialog
      scrollable
      v-model="visable"
      max-width="700px"
      :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在发布…': '确认发布？' }}
      </v-card-title>

      <v-divider></v-divider>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
        <div>

          <v-form v-model="formValid" ref="formRef" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>

                <v-flex sm6>
                  <v-menu
                      ref="refReceiveStartDate"
                      :close-on-content-click="false"
                      v-model="menuReceiveStartDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="item.startDate"
                        label="申报接收开始日期"
                        :rules="rules.startDate"
                        hint="格式YYYY-MM-DD"
                        persistent-hint
                    />
                    <v-date-picker
                        v-model="receiveStartDate"
                        locale="zh-cn"
                        @change="nv => item.startDate= nv"
                    />
                  </v-menu>
                </v-flex>

                <v-flex sm6>
                  <v-menu
                      ref="refReceiveEndDate"
                      :close-on-content-click="false"
                      v-model="menuReceiveEndDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="item.endDate"
                        label="申报接收截止日期"
                        :rules="rules.endDate"
                        hint="格式YYYY-MM-DD"
                        persistent-hint
                    />
                    <v-date-picker
                        v-model="receiveEndDate"
                        locale="zh-cn"
                        @change="nv => item.endDate= nv"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm12>
                  <v-autocomplete
                      label="选择申报评审标准"
                      clearable
                      required
                      :rules="rules.required"
                      v-model="templateId"
                      item-text="name"
                      item-value="dbid"
                      :items="tempItems"
                  />
                </v-flex>

                <v-flex xs12 sm12>
                  <v-textarea
                    label="备注信息"
                    counter="200"
                    v-model="note"
                  />
                </v-flex>

              </v-layout>
            </v-container>
          </v-form>

        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('input', false)">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onSubmit">发布</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const baseUri = '/api/proj/review-template';
export default {
  name: "PubReview",
  model: {
    prop: 'visable',
    event: 'input'
  },

  props: ['visable', 'message', 'uri', 'dbid', 'startdate', 'enddate'],
  data() {
    return {
      formValid: false,

      loading: false,
      note: '',
      templateId : null,

      item:{},

      tempItems: [],

      receiveStartDate: '',
      menuReceiveStartDate: false,

      receiveEndDate: '',
      menuReceiveEndDate: false,

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误',
          v => (v && v >= this.startdate) || "申报接收开始日期必须大于或等于申报开始日期。"
        ],
        endDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "申报接收截止日期必须晚于起始日期。"
        ]
      }

    }
  },
  methods: {
    onSubmit() {
      const vm = this;
      if (this.$refs.formRef.validate()) {
        if (vm.templateId) {
          //vm.loading = true;
          const titem =
              {
                "note": this.note,
                "receiveStartDate": this.receiveStartDate,
                "receiveEndDate": this.receiveEndDate,
                "templateId": this.templateId
              }
          this.axios.put(`${this.uri}/pub/${this.dbid}`, titem)
              .then(rsp => {
                window.console.log("rsp.data")
                window.console.log(rsp.data)
                vm.$emit('ok', rsp.data);
                vm.$emit('input', false);
                vm.$emit('reset', false);
                vm.loading = false;
              })
        } else {
          alert("请选择评审模版！")
        }
      }
    }
  },

  created() {
      this.axios.get(baseUri)
        .then(
                rspTemp => {
                  this.isLoading = false;
                  this.tempItems = rspTemp.data.items;
                }
        )
  }
}
</script>

<style scoped>

</style>